import './App.css';
import { useContext } from 'react';
import { UserContext } from './context/user';
import { Navigate, Route, Routes } from 'react-router';
import LogInUser from './pages/Auth/LoginUser';
import NavBar from './components/navigation/NavBar';
import Welcome from './pages/Main/Welcome';
import Section from './pages/Main/Section';
import Report from './pages/Main/Report';
import LoginAdmin from './pages/Auth/LoginAdmin';
import Dashboard from './pages/Admin/Dashboard';
import AssessmentMenu from './pages/Main/AssessmentMenu';
import Welcome360 from './pages/Main/Welcome360';
import Complete360 from './pages/Main/Complete360';
import ReviewAssessment from './pages/Public/ReviewAssessment';
import Report360 from './pages/Main/Report360';
import Setup360 from './pages/Main/Setup360';

function App() {

  const {currentUser} = useContext(UserContext);

  return (
    <>
      <Routes>
      {/* Public review route — always accessible regardless of auth state */}
      <Route path="/review/:token" element={<ReviewAssessment/>}/>
      {
        !currentUser &&
        <>
          <Route path="/" element={<NavBar/>}>
            <Route index element={<LogInUser/>}/>
            <Route path="/admin" element={<LoginAdmin/>}/>
          </Route>
          <Route path='*' element={<Navigate to="/"/>}/>
        </>
      }
      {
        currentUser && currentUser.rol === "user" && <>
          <Route path="/" element={<NavBar/>}>
            <Route index element={<AssessmentMenu/>}/>
            <Route path="/welcome" element={<Welcome/>}/>
            <Route path="/section/:id" element={<Section/>}/>
            <Route path="/report" element={<Report/>}/>
            <Route path="/group/:groupId/welcome" element={<Welcome360/>}/>
            <Route path="/group/:groupId/section/:id" element={<Section/>}/>
            <Route path="/group/:groupId/setup" element={<Setup360/>}/>
            <Route path="/group/:groupId/complete" element={<Complete360/>}/>
            <Route path="/group/:groupId/report" element={<Report360/>}/>
          </Route>
          <Route path='*' element={<Navigate to="/"/>}/>
        </>
      }
      {
        currentUser && currentUser.rol === "admin" && <>
          <Route path="/" element={<NavBar/>}>
            <Route index element={<Dashboard active={"home"}/>}/>
            <Route path="/admins" element={<Dashboard active={"admins"}/>}/>
            <Route path="/questions" element={<Dashboard active={"questions"}/>}/>
            <Route path="/sections" element={<Dashboard active={"sections"}/>}/>
            <Route path="/section-texts" element={<Dashboard active={"sectionTexts"}/>}/>
            <Route path="/wonder-of-you" element={<Dashboard active={"wonderOfYou"}/>}/>
            <Route path="/reports-360" element={<Dashboard active={"reports360"}/>}/>
            <Route path="/email-notifications" element={<Dashboard active={"emailNotifications"}/>}/>
            <Route path="/guide" element={<Dashboard active={"guide"}/>}/>
          </Route>
          <Route path='*' element={<Navigate to="/"/>}/>
        </>
      }
      </Routes>
    </>
  );
}

export default App;
